module.exports = __webpack_public_path__ + "static/media/service10.501caf4e.jpg";